export default "__VITE_ASSET__DaXyETZq__"